var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQualityScore = function SvgQualityScore(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 124 124"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    "data-name": "Rectangle 33691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 124,
    height: 124,
    stroke: "none",
    rx: 20
  }), /*#__PURE__*/React.createElement("rect", {
    width: 123,
    height: 123,
    x: 0.5,
    y: 0.5,
    fill: "none",
    rx: 19.5
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    "data-name": "Group 57685"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.424 67.171 15.837 90.696a3.39 3.39 0 0 0 2.551 5.62h10.906l2.75 10.987a3.39 3.39 0 0 0 2.915 2.546 4 4 0 0 0 .371.02 3.39 3.39 0 0 0 3.031-1.873l14.952-29.9a33.94 33.94 0 0 1-16.889-10.925",
    "data-name": "Path 50547"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.032 90.696 88.446 67.171a33.94 33.94 0 0 1-16.888 10.92l14.952 29.9a3.39 3.39 0 0 0 3.03 1.88 4 4 0 0 0 .371-.02 3.39 3.39 0 0 0 2.915-2.546l2.75-10.987h10.905a3.39 3.39 0 0 0 2.551-5.62Z",
    "data-name": "Path 50548"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.928 45.493a30.494 30.494 0 1 0-30.493 30.493 30.53 30.53 0 0 0 30.493-30.493M43.8 57.309l-3.141 1.736.6-3.678-2.541-2.6 3.512-.536 1.57-3.346 1.57 3.346 3.512.536-2.541 2.6.6 3.678Zm13.306 11.9-3.141-1.736-3.141 1.736.6-3.678-2.541-2.6 3.512-.536 1.57-3.346 1.57 3.346 3.512.536-2.541 2.6Zm-1.448-23.716a6.784 6.784 0 0 1 6.776-6.776 6.7 6.7 0 0 1 3.42.96l10.63-10.629a1.697 1.697 0 0 1 2.4 2.4L68.251 42.072a6.7 6.7 0 0 1 .96 3.421 6.777 6.777 0 1 1-13.553 0M74.046 69.21l-3.141-1.736-3.141 1.736.6-3.678-2.541-2.6 3.512-.536 1.57-3.346 1.57 3.346 3.512.536-2.541 2.6Zm3.882-10.165.6-3.678-2.541-2.6 3.512-.536 1.57-3.346 1.57 3.346 3.512.536-2.541 2.6.6 3.678-3.14-1.736Z",
    "data-name": "Path 50549"
  }))));
};
export default SvgQualityScore;